import { IAccountServices } from 'services/RawData/account_services';
import { LayoutHOC } from 'base/ui/layout/layout';
import createChangeAfter90DaysPassword from '.';

export const createChangePasswordAfter90DaysPage = (service: IAccountServices) => {
    return createChangeAfter90DaysPassword(service);
};
